export default "__VITE_ASSET__CSQvd8Hy__"